import React from 'react';
import usePermissions from '../hooks/usePermissions';
import { useTranslation } from 'react-i18next';

/**
 * Gate RBAC réutilisable — wrappe un module ou une section et empêche le
 * rendu de ses enfants si l'utilisateur n'a pas la permission.
 *
 * Utilisation type dans App.js :
 *
 *   case 'paie':
 *     return (
 *       <RBACGate moduleId="paie" tenantSlug={tenantSlug} user={user}>
 *         <ModulePaie tenant={tenantSlug} />
 *       </RBACGate>
 *     );
 *
 * Garantit que le composant enfant n'est JAMAIS instancié si pas d'accès,
 * même si l'utilisateur force le state ou l'URL. Le hook bypass admin
 * automatiquement (permissions.is_full_access).
 */
const RBACGate = ({ moduleId, tenantSlug, user, children, fallback }) => {
  const { t } = useTranslation();
  const { canViewModule, loading } = usePermissions(tenantSlug, user);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
        {t('rbacGate.chargementDesPermissions')}
      </div>
    );
  }

  if (!canViewModule(moduleId)) {
    if (fallback !== undefined) return fallback;
    return (
      <div style={{
        padding: '3rem 2rem',
        textAlign: 'center',
        background: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '12px',
        margin: '2rem auto',
        maxWidth: '500px',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚫</div>
        <h2 style={{ color: '#991b1b', marginBottom: '0.5rem' }}>{t('rbacGate.accesRefuse')}</h2>
        <p style={{ color: '#7f1d1d', margin: 0 }}>
          {t('rbacGate.vousNAvezPasLaPermission')}
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RBACGate;
